import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableFooter, Typography } from '@mui/material';
import { warehousesContext } from '../WarehousesContext';
import { CircleLoader, DeleteIconButton, EditIconButton } from 'components';

let Results = () => {
    let service = useContext(warehousesContext);

    return (
        <div>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Virtual</TableCell>
                            <TableCell>Warehouse list</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.warehouses.length > 0 &&
                            service.warehouses
                                .map((warehouse, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell>{warehouse.code}</TableCell>
                                        <TableCell>{warehouse.isVirtual === true ? 'Yes' : 'No'}</TableCell>
                                        <TableCell>
                                            {warehouse.warehouseList
                                                .map((x, idx) => `${x} ${idx < warehouse.warehouseList.length - 1 ? ', ' : ' '}`)
                                            }
                                        </TableCell>
                                        <TableCell align="right">
                                            <EditIconButton link={`/admin/warehouse/edit/${warehouse.id}`} />
                                            <DeleteIconButton onClick={() => service.deleteWarehouse(warehouse.id)} />
                                        </TableCell>
                                    </TableRow>
                                )}
                    </TableBody>
                    {service.warehouses.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={4}>
                                    <Typography variant="subtitle2">No warehouses found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
            {service.isLoading === false &&
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={service.handleChangePage}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                />
            }
        </div >
    );
}

export default Results;